import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, PenLine } from "lucide-react";

const PLANNED_TOPICS = [
  "LGPD em hospitais: da teoria à prática",
  "Como escolher indicadores gerenciais em saúde",
  "IA aplicada à gestão de leitos",
  "Integração com Tasy: erros comuns e boas práticas",
  "Assinatura digital ICP-Brasil em documentos clínicos",
  "Cloud na saúde: quando (e quando não) migrar",
];

export default function Blog() {
  useEffect(() => {
    document.title = "Blog — Áxis Saúde Digital";
  }, []);

  return (
    <div data-testid="blog-page">
      <section className="bg-white pt-16 lg:pt-24 pb-24">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <p className="font-mono-axis text-xs uppercase tracking-widest text-[#1E3A8A] mb-4">
            Blog · Em breve
          </p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-semibold text-[#111827] leading-[1.05]">
            Ideias sobre{" "}
            <span className="text-[#1E3A8A]">tecnologia</span> e saúde.
          </h1>
          <p className="mt-6 text-base md:text-lg text-gray-600 leading-relaxed max-w-2xl">
            Estamos preparando artigos técnicos, estudos de caso e análises
            sobre saúde digital, IA aplicada, LGPD e a operação de sistemas
            críticos hospitalares.
          </p>

          <div className="mt-16 border border-gray-200">
            <div className="p-8 lg:p-10 border-b border-gray-200 flex items-start gap-4">
              <div className="w-11 h-11 bg-[#1E3A8A] text-white flex items-center justify-center shrink-0">
                <PenLine className="w-5 h-5" strokeWidth={1.75} />
              </div>
              <div>
                <p className="font-mono-axis text-xs uppercase tracking-widest text-gray-500">
                  Editorial
                </p>
                <h2 className="mt-2 font-display text-xl lg:text-2xl font-medium tracking-tight text-[#111827]">
                  Próximos tópicos em produção
                </h2>
              </div>
            </div>
            <ul className="divide-y divide-gray-200">
              {PLANNED_TOPICS.map((t, i) => (
                <li
                  key={t}
                  className="flex items-center justify-between px-8 lg:px-10 py-5 hover:bg-[#F9FAFB] transition-colors"
                >
                  <span className="flex items-center gap-4">
                    <span className="font-mono-axis text-xs text-gray-400 w-6">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-base text-[#111827] font-medium">
                      {t}
                    </span>
                  </span>
                  <span className="font-mono-axis text-xs uppercase tracking-widest text-gray-400">
                    Em breve
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-14 flex flex-col md:flex-row md:items-center gap-4">
            <p className="text-sm text-gray-600">
              Quer ser avisado quando publicarmos?
            </p>
            <Link
              to="/contato"
              data-testid="blog-cta"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-[#1E3A8A] text-white text-sm font-medium hover:bg-[#172554] transition-colors"
            >
              Entrar em contato
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
